"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAlignment = void 0;
var TextAlignment;
(function (TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})(TextAlignment = exports.TextAlignment || (exports.TextAlignment = {}));
//# sourceMappingURL=alignment.js.map


// WEBPACK FOOTER //
// ./~/pdf-lib/cjs/api/text/alignment.js